const types = {
  UPDATE_USER: "UPDATE_USER",
};
export default types;

export const updateUserRedux = (payload) => {
  return { type: types.UPDATE_USER, payload };
};
